import { render, staticRenderFns } from "./PrePhoto.vue?vue&type=template&id=730dfa3f&scoped=true"
import script from "./PrePhoto.vue?vue&type=script&lang=js"
export * from "./PrePhoto.vue?vue&type=script&lang=js"
import style0 from "./PrePhoto.vue?vue&type=style&index=0&id=730dfa3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730dfa3f",
  null
  
)

export default component.exports